import Joi from 'joi';

export const ProgressSchema = Joi.object({
  projectId: Joi.number().required(),
  spentTypeId: Joi.number().required(),
  spentDate: Joi.date().required(),
  spent: Joi.number().required(),
  percent: Joi.number().required().min(0).max(100),
});

export const ProgressAttachmentSchema = Joi.object({
  name: Joi.string().required(),
  file: Joi.string().required(),
});
